import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import AgeGate from "./components/AgeGate";
import Navbar from "./components/Navbar";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import CreateStory from "./pages/CreateStory";
import StoryReader from "./pages/StoryReader";
import Characters from "./pages/Characters";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/sonner";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/auth" replace />;
  return children;
};

const AppRoutes = () => {
  const { user } = useAuth();
  return (
    <>
      {user && <Navbar />}
      <Routes>
        <Route path="/" element={user ? <Navigate to="/dashboard" /> : <Landing />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/create" element={<Protected><CreateStory /></Protected>} />
        <Route path="/story/:id" element={<Protected><StoryReader /></Protected>} />
        <Route path="/characters" element={<Protected><Characters /></Protected>} />
        <Route path="/admin" element={<Protected><Admin /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <AgeGate>
            <BrowserRouter>
              <AppRoutes />
              <ThemedToaster />
            </BrowserRouter>
          </AgeGate>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

const ThemedToaster = () => {
  const { theme } = useTheme();
  return <Toaster position="bottom-right" theme={theme} />;
};

export default App;
